// extracted by mini-css-extract-plugin
export default {"container":"SOIAnalysisContainer_container__0s94x"};